module.exports = __webpack_public_path__ + "img/texas_dark_grey_ba_detail_rsh1(1).566a388e.jpg";